module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_wear_9ac7dfddcfa898e8b200048eaf91fb92.png";